// @flow
// $FlowFixMe
import React, { useEffect } from 'react';
import { Link } from 'react-router';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import type { Person } from '../../shapes/types';
import CapacitorHeaderBar from '../capacitor/HeaderBar';
import CapacitorRipple from '../capacitor/Ripple';
import styles from '../../views/GenericList.css';
import LocalListSearch from './LocalListSearch';
import List from '../util/List';
import PaginatedList from '../util/PaginatedList';

declare var __CAPACITOR__: boolean;

type OwnProps = {
  location: Object,
  showShareModal: Function,
};

type MapStateToProps = {
  items: Array<Person>,
  currentCursor?: string,
  nextCursor?: string,
  prevCursor?: string,
  isLoading: boolean,
  searchQuery: string,
  artistType: string,
  title: Object,
};

type DispatchProps = {
  loadItems: Function,
  setSearchQuery: Function,
};

type Props = OwnProps & MapStateToProps & DispatchProps & { intl: IntlShape };

const ArtistListPage = ({
  items,
  currentCursor,
  nextCursor,
  prevCursor,
  showShareModal,
  isLoading,
  location,
  loadItems,
  searchQuery,
  setSearchQuery,
  artistType,
  title,
  intl,
}: Props) => {
  const renderItem = (item: Person) => {
    return (
      <li key={item.id}>
        <Link to={`/profiles/${item.id}`} className={styles.link}>
          <CapacitorRipple />
          {item.surname && item.forename ? (
            <React.Fragment>
              <strong>{item.surname}</strong>, {item.forename}
            </React.Fragment>
          ) : (
            item.name
          )}
        </Link>
      </li>
    );
  };

  const loadMore = () => {
    if (!isLoading && nextCursor) {
      loadItems(nextCursor, searchQuery);
    }
  };

  const onSearchChange = async (query: string) => {
    setSearchQuery(query);
  };

  useEffect(() => {
    loadItems(currentCursor, searchQuery);
  }, [currentCursor, searchQuery, loadItems]);

  const formattedTitle = intl.formatMessage(title);

  return (
    <div className="u-page-container" data-test={`${artistType}-page`}>
      {__CAPACITOR__ && (
        <CapacitorHeaderBar
          showShareModal={showShareModal}
          title={formattedTitle}
          onlyShowTitleOnScroll
          showSearch
        />
      )}
      <h1 className="fz--beta">{formattedTitle}</h1>
      <LocalListSearch
        query={searchQuery}
        onSearchChange={onSearchChange}
        id={`${artistType}-search-box-input`}
        type={artistType}
        className={styles.searchBox}
        minQueryLength={1}
      />
      <PaginatedList
        isLoading={isLoading}
        currentCursor={currentCursor}
        nextCursor={nextCursor}
        prevCursor={prevCursor}
        location={location}
        loadMore={loadMore}
      >
        <List items={items} renderItem={renderItem} />
      </PaginatedList>
    </div>
  );
};

export default injectIntl(ArtistListPage);
